import { Paper, Typography } from '@mui/material'
import { useFormikContext } from 'formik'
import { calculateIdade } from './CheckoutContext'

const PacienteCard = () => {
  const { values } = useFormikContext()
  const idade = calculateIdade(values.dtNascimento)

  return (
    <Paper
      sx={{
        borderRadius: 3,
        boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
        p: 2,
        gap: 2,
        display: 'flex',
      }}
    >
      <Typography sx={{ fontWeight: 700, fontSize: 18 }}>
        {values.dsPaciente}
      </Typography>
      {idade && (
        <Typography variant="body2" sx={{ color: 'text.secondary', mt: 0.5 }}>
          {idade}
        </Typography>
      )}
    </Paper>
  )
}

export default PacienteCard
